module.exports = __webpack_public_path__ + "fonts/Onest-Medium.fbd1029.ttf";